import { render, staticRenderFns } from "./editBaseInfoDailog.vue?vue&type=template&id=646716fe&scoped=true"
import script from "./editBaseInfoDailog.vue?vue&type=script&lang=js"
export * from "./editBaseInfoDailog.vue?vue&type=script&lang=js"
import style0 from "./editBaseInfoDailog.vue?vue&type=style&index=0&id=646716fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "646716fe",
  null
  
)

export default component.exports